import { proxy } from 'valtio';

type AlgoliaState = {
  sortBy: string | null;
};

export const algoliaStateActions = {
  updateSortBy: (sortBy: string) => {
    algoliaState.sortBy = sortBy;
  },
};

export const algoliaState = proxy<AlgoliaState>({
  sortBy: null,
});
